
import { Component, Vue } from 'vue-property-decorator';
import draggable from 'vuedraggable';
import { findLastIndex } from 'lodash';

import StatusRow from './Row.vue';
import AddRow from './AddRow.vue';
import SettingsStatusesRow from './SettingsStatusesRow.vue';

const MAX_STATUSES_IN_THE_ROW = 6;

@Component({
  name: 'SettingsStatuses',
  components: {
    draggable,
    StatusRow,
    SettingsStatusesRow,
    AddRow
  }
})
export default class SettingsStatuses extends Vue {
  private drag = false;
  private addingNewRow = false;
  private tempStatuses = null;

  get statusesDummies() {
    if (this.statusesLine.length < MAX_STATUSES_IN_THE_ROW) {
      const arr = new Array(MAX_STATUSES_IN_THE_ROW - this.statusesLine.length);

      return arr.fill({ id: null }).map((item, idx) => ({ id: idx }));
    }

    return [];
  }

  get statusesLine() {
    const statuses = this.$store.getters['dictionary/responseStatuses'];

    return statuses
      .filter(s => s.on_top)
      .slice(0, MAX_STATUSES_IN_THE_ROW)
      .map(status => {
        return {
          ...status,
          label: status.name
        };
      });
  }

  get haveSpaceInTheStatusBar() {
    return this.statusesLine.length < MAX_STATUSES_IN_THE_ROW;
  }

  get statuses() {
    return this.$store.getters['dictionary/responseStatuses'];
  }
  set statuses(val) {
    this.tempStatuses = val;
  }

  get lastBaseIndex() {
    return findLastIndex(this.$store.getters['dictionary/responseStatuses'], {
      is_base: true
    });
  }

  public createNewStatus(name) {
    this.$store.dispatch('dictionary/createResponseStatus', name).catch(e => {
      this.$noty.error(e.data.meta.error.message);
    });
  }

  public fetch() {
    this.$store.dispatch('dictionary/fetchStagesAndStatuses', {
      with_count: 'all'
    });
  }

  public toggleNewStatus() {
    this.addingNewRow = !this.addingNewRow;
  }

  public checkMove({ draggedContext: { element, futureIndex } }) {
    return !element.is_base && futureIndex > this.lastBaseIndex;
  }

  public endDrag(ev) {
    this.drag = false;

    this.$store.dispatch('dictionary/updateResponseStatusesPriority', {
      statuses: this.tempStatuses,
      fromIndex: Math.min(ev.newIndex, ev.oldIndex)
    });
  }

  beforeMount() {
    this.fetch();
  }
}
